import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { Constants } from '../../providers/constants/constants';
import { PlanStatusService } from '../service/plan-status/plan-status.service';

/**
 * Guard de autenticación para rutas protegidas de la aplicación.
 * Verifica la existencia de una sesión activa en `localStorage` y, además,
 * dispara la validación del estado del plan de la organización.
 */
@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(
    private router: Router,
    private planStatusService: PlanStatusService
  ) {}

  /**
   * Determina si el usuario puede acceder a una ruta protegida.
   * Si existe sesión activa, ejecuta la validación del plan y permite el acceso.
   * En caso contrario, redirige al login.
   *
   * @returns `true` si el usuario está autenticado; `false` si se redirige al login.
   */
  canActivate(): boolean {
    const userData = localStorage.getItem(Constants.localStorage.user);
    if (userData) {
      // Valida el estado del plan en cada acceso a rutas protegidas
      this.planStatusService.validarEstadoPlan();
      return true;
    }

    this.router.navigate(['/login']);
    return false;
  }
}